import CollapsibleListColumns from './CollapsibleListColumns';
export default CollapsibleListColumns;